import { useDispatch } from 'react-redux';
import get from 'lodash.get';
import reduxConstants from 'lib/reusable-components/reusableUtils/redux/reduxConstants';
import { create } from 'lib/reusable-components/reusableUtils/redux/stateSlice';
import store from 'lib/reusable-components/reusableUtils/redux/store';

export default function useUpdateConnectionsSchema() {
  const dispatch = useDispatch();
  /**
   * isDelete - true for delete operation, false for connection creation
   * path - The key of connection to be deleted
   * newObj - the object of new connection in case of connection creation
   * key - the key (connection ID)
   */
  return (isDelete, path, newObj, key, update = false, newKey) => {
    const schema =
      store.getState()[reduxConstants.STORE_NAME][reduxConstants.config.ANALYTICS_SCHEMA][
        'appCreds'
      ];
    let newAppCredentials;
    console.log(isDelete, path, newObj, key, update, newKey, 'custom hook');
    if (isDelete) {
      newAppCredentials = { ...schema };
      delete newAppCredentials[path];
    }
    // else if(update) {
    //   newAppCredentials = {...schema};
    //   delete newAppCredentials[key];

    //   newAppCredentials = { [newKey]: {...newObj}, ...newAppCredentials };
    // }
    else {
      newAppCredentials = { [key]: newObj, ...schema };
    }
    dispatch(
      create({
        setPath: `${reduxConstants.config.ANALYTICS_SCHEMA}.appCreds`,
        value: newAppCredentials,
      })
    );
  };
}
